<template>
  <div class="mega-menu shadow-sm">

    <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin" style="color:#000;"></i></div>

    <ul v-else class="category-list">
      <li>
        <button class="category-button shop-by">Shop by Department</button>
      </li>
      <div class="py-1 spacing"></div>
      <li v-for="(category, index) in categories" :key="index">
        <button class="category-button">{{category.name}}</button>
        <ul class="subcategory-list shadow-sm py-2">
          <li v-for="(subCategory, index) in category.sub_categories" :key="index">
            <a :href="`/category/${subCategory.id}/${createSlug(subCategory.name)}`">{{subCategory.name}}</a>
          </li>
        </ul>
      </li>
      <div class="py-1 spacing"></div>
      <!-- <li><button class="category-button specials" @click="showMessage()">Specials</button></li> -->
    </ul>
  </div>
</template>

<script>
export default {

  data() {
    return {
      categories: [],
      loading: false,
    };
  },

  created() {
    this.getCategories();
  },

  methods: {
    showMessage() {
      this.sweetfire('No specials right now');
    },

    sweetfire(text) {
      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: { title: "popup-title" },
      })
    },

    getCategories() {

      this.loading = true;

      axios
        .get('/category/list')
        .then((response) => {
          this.categories = response.data;
          this.loading = false;
        });
    },

  },
};
</script> 
